import { render, staticRenderFns } from "./CouponInput.vue?vue&type=template&id=dd6af048&scoped=true&"
import script from "./CouponInput.vue?vue&type=script&lang=js&"
export * from "./CouponInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6af048",
  null
  
)

export default component.exports